var map = {
	"./1994.png": 87,
	"./1995-2012.png": 88,
	"./2006.png": 89,
	"./2012.png": 90,
	"./2013.png": 91,
	"./2014.png": 92,
	"./2015.png": 93,
	"./2017.png": 94,
	"./left-marker.svg": 95,
	"./right-marker.svg": 96
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;


//////////////////
// WEBPACK FOOTER
// ./src/images/timeline nonrecursive \.(png|svg)$
// module id = 86
// module chunks = 0